/** * Loading 加载动画组件 */

<template>
  <div
    class="logoImg"
    v-if="logo.localUrl != ''"
    :style="`background-image:url(${logo.localUrl})`"
  >
    <div class="logoImgShadow" v-if="logo.showProgress">
      <span class="logoImgProgress" v-if="logo.progress !== 100">{{
        logo.progress === -1 ? "上传失败" : logo.progress + "%"
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressImg",
  props: {
    logo: {
      type: Object
    }
  },
  data() {
    return {};
  },
  components: {},
  methods: {},
  create() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.logoImg {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  .logoImgShadow {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
    .logoImgProgress {
      color: #ffffff;
      font-size: 20px;
    }
  }
}
</style>
